import { j as json } from "../../../../chunks/index2.js";
import admin from "firebase-admin";
import { randomUUID } from "crypto";
import { s as sendLicenseVerifiedEmail, a as sendEmailVerification } from "../../../../chunks/mailer.js";
const GET = async ({ url }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  const code = searchParams.get("code");
  if (email && code) {
    const verificationCode = await admin.firestore().collection("verificationCodes").doc(email).get();
    if (verificationCode.exists) {
      const verified = verificationCode.data()?.code === code;
      if (verified) await sendLicenseVerifiedEmail(email);
      return json({ verified }, { status: verified ? 200 : 403 });
    }
    return json({ error: "Verification code not found" }, { status: 404 });
  }
  if (email) {
    const id = randomUUID().split("-").join("");
    const code2 = id.substring(0, 6).toUpperCase();
    const docRef = admin.firestore().collection("verificationCodes").doc(email);
    await docRef.set({ code: code2 });
    await sendEmailVerification(email, code2);
    return json({ success: true });
  }
  return json({ error: "No email or code provided" }, { status: 400 });
};
export {
  GET
};
